export default {"src":"/_next/static/media/squad-mini.5f5eadb6.svg","height":40,"width":34,"blurWidth":0,"blurHeight":0};